export default __webpack_public_path__ + "static/media/paso2-icon.4e56e9f0.svg";